module.exports = __webpack_public_path__ + "static/media/stethoscope.462f4a78.svg";